import React, { useContext, useState, useEffect } from "react"
import TopSearch from "@/components/TopSearch"
import ListComponent from "@/components/listComponent"
import { intentionFranchisePage } from "@/service/orgService"
import { MyContext } from "@/store/myContext"
import Detail from "./detail"
import { Select } from "antd"
const { Option } = Select

export default () => {
  const { state, message } = useContext(MyContext)
  const [showVisible, setShowVisible] = useState(false)
  const [showMode, setShowMode] = useState("")
  const [list, setList] = useState([]) //列表
  const [searchValue, setSearchValue] = useState({})
  const [pagination, setpagination] = useState({
    total: 0,
    current: 1,
    pageSize: 10,
  })
  const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标及信息

  useEffect(() => {
    if (state.activeMenu === "intentionFranchise") {
      loadData(pagination.current)
    }
  }, [state.activeMenu])

  //列表数据
  const loadData = (current, search = {}) => {
    let data = {
      searchItem: { ...search },
      pageNum: current,
      pageSize: 10,
      orders: [
        {
          column: "createTime",
          rule: "DESC",
        },
      ],
    }
    intentionFranchisePage(data).then((res) => {
      setpagination({
        current: current,
        total: res.retData.total,
        pageSize: 10,
      })
      setSelectInfo({ rowInfo: {}, rowIndex: -1 })
      setList(res.retData.list)
    })
  }

  //分页事件
  const onTableChange = async (page) => {
    await setpagination({
      ...pagination,
      current: page.current,
    })
    loadData(page.current, searchValue)
  }

  //列表button
  const topButtons = [
    {
      click: () => handleDetails("edit"),
      content: "编辑",
    }
  ]

  //编辑
  const handleDetails = async (mode) => {
    if (!Object.keys(selectInfo.rowInfo).length) {
      message.warning("请选择要编辑的记录")
      return
    }
    setShowMode(mode)
    setShowVisible(true)
  }

  //table配置
  const columns = [
    {
      title: '序号',
      width: 50,
      align: "center",
      render: (t, r, i) => i + 1
    },
    {
      title: "姓名",
      width: 100,
      align: "center",
      dataIndex: "name",
    },
    {
      title: "电话",
      width: 120,
      align: "center",
      dataIndex: "phone",
    },
    {
      title: "公司名称",
      width: 150,
      align: "center",
      dataIndex: "companyName",
    },
    {
      title: "主营业务",
      width: 150,
      align: "center",
      dataIndex: "mainBusiness",
    },
    {
      title: "是否回访",
      width: 100,
      align: "center",
      dataIndex: "follow",
      render: (text) => text === 1 ? "是" : "否"
    },
    {
      title: "备注",
      width: 200,
      align: "center",
      dataIndex: "remark",
    },
    {
      title: "添加时间",
      width: 160,
      align: "center",
      dataIndex: "createTime",
    },
  ]

  //搜索JSON
  const searchList = {
    normalList: [
      {
        type: "input",
        placeholder: "姓名",
        valueName: "name",
      },
      {
        type: "select",
        placeholder: "是否回访",
        valueName: "follow",
        optionList: () => (
          <>
            <Option value={1} key={1}>是</Option>,
            <Option value={0} key={0}>否</Option>
          </>
        ),
      },
      {
        type: "input",
        placeholder: "公司名称",
        valueName: "companyName",
      },
    ],
  }

  return (
    <>
      <TopSearch
        title=""
        searchListData={searchList}
        searchValue={searchValue}
        setSearchValue={(obj) => setSearchValue(obj)}
        handleSearch={loadData}
      />
      <ListComponent
        title="意向加盟"
        buttons={topButtons}
        selectInfo={selectInfo}
        columns={columns}
        scroll={1500}
        dataSource={list}
        pagination={pagination}
        onTableChange={onTableChange}
        setSelectInfo={(obj) => setSelectInfo(obj)}
      />

      {showVisible && (
        <Detail
          rowInfo={selectInfo.rowInfo}
          visible={showVisible}
          mode={showMode}
          setVisible={setShowVisible}
          onSuccess={() => {
            loadData(1, searchValue)
          }}
        />
      )}
    </>
  )
} 